import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Spin,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  InputNumber,
  message,
  Checkbox,
  Select,
  Switch,
} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import { useHistory } from "react-router-dom";
import { InputGroup } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  formatDigits,
  getRandomInt,
  notAllowMsgCheck,
  setCommonConfigs,
} from "../../../appRedux/actions";
import { SALES_DISCOUNT_SCREEN } from "../../../constants/Pages";
import {
  READ,
  CREATE,
  UPDATE,
  DELETE,
} from "../../../constants/RightsAndPermissions";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { TableName } from "../../../constants/TableName";
import NotAllowedComponent from "../../../components/NotAllowedComponent";

const SalesDiscount = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const confirm = Modal.confirm;
  const dispatch = useDispatch();

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  const [visible, setVisible] = useState(false);
  const [groupVisible, setGroupVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false); // change state
  const [groupLoading, setGroupLoading] = useState(false); // change state
  const [taxData, setTaxData] = useState([]);
  const [taxDataForGroup, setTaxDataForGroup] = useState([]);
 // const [groupTaxes, setGroupTaxes] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [groupEdit, setGroupEdit] = useState(false);
  const [taxId, setTaxId] = useState();
  const [code, setCode] = useState();
 // const [outletTax, setOutletTax] = useState([]);
  const [loadDataState, setloadDataState] = useState(false);
  const [loadGroupData, setloadGroupData] = useState(false);
  const [isPercent, setIsPercent] = useState(true);
  const [getIsAllowRead, setIsAllowRead] = useState(false);
  const [getIsDisableCreate, setIsDisableCreate] = useState(true);
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true);
  const [getIsDisableDelete, setIsDisableDelete] = useState(true);
  const [getAccessLoading, setAccessLoading] = useState(true);
  const [getTaxValue, setTaxValue] = useState("");
  const [getRights, setRights] = useState([]);
  const [getPermissions, setPermissions] = useState([]);
  const [getCurrData, setCurrData] = React.useState({
    currencyCode: "",
    currencyName: "",
    currencySymbol: "",
  });
  const [getNbrOfFields, setNbrOfFields] = useState([
    getRandomInt(1000000),
    getRandomInt(1000000),
  ]);
  const [isDiscountActive, setIsDiscountActive] = useState(true)

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting;
    let rites = [];
    let permissions = [];
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {};
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrData(currencyData);
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites;
        setRights(rites);
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
            .permission;
        setPermissions(permissions);
      }
    }

    if (rites.length > 0) {
      if (rites.filter((a) => a == READ).length > 0) {
        setIsAllowRead(true);
      }
      if (rites.filter((a) => a == CREATE).length > 0) {
        setIsDisableCreate(false);
        //redirect from home
        // if (window.location.href.includes("/mainadd")) {
        //   setVisible(true);
        // }
      }
      //  else {
      //   if (window.location.href.includes("/mainadd")) {
      //     message.info("User don't have the right to create.");
      //   }
      // }
      if (rites.filter((a) => a == UPDATE).length > 0) {
        setIsDisableUpdate(false);
      }
      if (rites.filter((a) => a == DELETE).length > 0) {
        setIsDisableDelete(false);
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false);
    }
  }, [getReduxCommonSetting]);

  useEffect(() => {
    setConfirmLoading(true);
    debugger
    ds.getSalesDiscountList("1", BEHAVIOUR_TYPE.GET)
      .then((res) => {
        debugger
        setConfirmLoading(false);
        if (res && res.length > 0) {
          let array = res.map((e) => {
            return {
              id: e.salesDiscSId,
              discountRate: e.discountRate
                ? formatDigits(e.discountRate, getDecimalPlaces)
                : parseFloat("0.00").toFixed(getDecimalPlaces),
                discountName: e.discountName,
                discountCode: e.discountCode,
                isActive: e.isActive ? "Yes" : "No",
                isFix: e.isFix ? e.isFix : false,
            };
          });
          setTaxData(array);
          //setTaxDataForGroup(array);
        } else {
          //setTaxDataForGroup([]);
          setTaxData([]);
        }
      })
      // .then(() => {
      //   ds.getOutletTax("", BEHAVIOUR_TYPE.GET).then((res) => {
      //     setConfirmLoading(false);
      //     if (res && res.length > 0) {
      //       let array = res.map((e) => {
      //         return {
      //           id: e.salesTaxSId,
      //           outletName: e.outletName,
      //           salesTaxName: e.salesTaxName,
      //         };
      //       });
      //      // setOutletTax(array);
      //     } else {
      //      // setOutletTax([]);
      //     }
      //     // if (loadDataState) setloadDataState(false);
      //   });
      // })
      .catch((error) => {
        notAllowMsgCheck(error);
        setConfirmLoading(false);
      });
  }, [loadDataState]);

  useEffect(() => {
    dispatch(setCommonConfigs(SALES_DISCOUNT_SCREEN));
  }, []);


  const handleCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  const handleGroupCancel = () => {
    form.resetFields();
    setGroupVisible(false);
  };

  const columnsTable1 = [
    {
      title: <IntlMessages id="setup.salesDiscount.disNamelbl" />,
      dataIndex: "discountName",
      key: "discountName",
      render: (text, record) => {
        return <span style={{ fontWeight: "500" }}>{record.discountName}</span>;
      },
    },
    {
        title: <IntlMessages id="setup.salesDiscount.disCodelbl" />,
        dataIndex: "discountCode",
        key: "discountCode",
        render: (text, record) => {
          return <span style={{ fontWeight: "500" }}>{record.discountCode}</span>;
        },
      },
    {
      title: <IntlMessages id="setup.salesDiscount.disRatelbl" />,
      dataIndex: "discountRate",
      key: "discountRate",
      render: (text, record) => {
        return (
          <span style={{ fontWeight: "500" }}>
            {`${record.discountRate}`}
            {record.isFix
              ? ` ${getCurrData.currencyCode ? getCurrData.currencyCode : ""}`
              : " %"}
          </span>
        );
      },
    },
    {
        title: <IntlMessages id="setup.salesDiscount.disActivelbl" />,
        dataIndex: "isActive",
        key: "isActive",
        render: (text, record) => {
          return <span style={{ fontWeight: "500" }}>{record.isActive}</span>;
        },
      },
    {
      title: <IntlMessages id="setup.outletsandregisters.tempcol2" />,
      dataIndex: "edit",
      key: "edit",
      render: (text, record) => {
        return getIsDisableUpdate ? (
          <Tag color="#f50">
            <strong>
              <IntlMessages id="dakarpos.allow.accessdenied" />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a onClick={() => handleEdit(record.id)} className="pen-edit">
                <i className="icon icon-edit" />
              </a>
            </span>
          </div>
        );
      },
    },
    {
      title: <IntlMessages id="products.brands.delete" />,
      key: "delete",
      render: (text, record) => {
        return getIsDisableDelete ? (
          <Tag color="#f50">
            <strong>
              <IntlMessages id="dakarpos.allow.accessdenied" />
            </strong>
          </Tag>
        ) : record &&
          record.salesTaxName &&
          record.salesTaxName.toLowerCase().includes("no tax") ? (
          <></>
        ) : (
          <span>
            <a
              onClick={() => showConfirmDelete(record.id)}
              className="trash-icon-btn"
            >
              <i className="icon icon-trash" />
            </a>
          </span>
        );
      },
    },
  ];

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 24 },
    },
  };

  const postTaxService = (values) => {
    setConfirmLoading(true);
    if (isEdit) {
      ds.postTax(
        {
          TaxName: values.taxName,
          SalesTaxID: taxId,
          Behavior: 3,
          IsFix: !isPercent,
        },
        BEHAVIOUR_TYPE.UPDATE
      )
        .then((res) => {
          setConfirmLoading(false);
          setVisible(false);
          setloadDataState(!loadDataState);
          form.resetFields();
          message.success("Data saved successfully");
        })
        .catch((error) => {
          notAllowMsgCheck(error);
          setConfirmLoading(false);
          message.error("Unable to save data");
        });
    } else {
      ds.postTax(
        {
          TaxName: values.taxName,
          TaxValue: formatDigits(values.taxRate, getDecimalPlaces), //values.taxRate,
          Behavior: 1,
          IsFix: !isPercent,
        },
        BEHAVIOUR_TYPE.POST
      )
        .then((res) => {
          setConfirmLoading(false);
          setVisible(false);
          setloadDataState(!loadDataState);
          form.resetFields();
          message.success("Data saved successfully");
        })
        .catch((error) => {
          notAllowMsgCheck(error);
          setConfirmLoading(false);
          message.error("Unable to save data");
        });
    }
  };

  const postGroupTaxService = (values) => {
    setConfirmLoading(true);
    if (groupEdit) {
      ds.postTax(
        {
          TaxName: values.taxName,
          SalesTaxID: taxId,
          Behavior: 3,
          IsFix: !isPercent,
        },
        BEHAVIOUR_TYPE.UPDATE
      )
        .then((res) => {
          setConfirmLoading(false);
          setVisible(false);
          setloadDataState(!loadDataState);
          form.resetFields();
          message.success("Data saved successfully");
        })
        .catch((error) => {
          notAllowMsgCheck(error);
          setConfirmLoading(false);
          message.error("Unable to save data");
        });
    } else {
      let ids = [];
      getNbrOfFields &&
        getNbrOfFields.length > 0 &&
        getNbrOfFields.map((a) => {
          const id = form.getFieldValue(`groupedTaxes${a}`);
          if (id && id != "") {
            ids.push(id);
          }
        });
      if (ids && ids.length > 0 && values.groupTaxName) {
        ds.postTax(
          {
            TaxName: values.groupTaxName ? values.groupTaxName : "",
            TaxValue: "0",
            Behavior: 1,
            SalesTaxIDs: ids,
            IsGroup: true,
          },
          BEHAVIOUR_TYPE.POST
        )
          .then((res) => {
            setConfirmLoading(false);
            setGroupVisible(false);
            setloadGroupData(!loadGroupData);
            form.resetFields();
            message.success("Data saved successfully");
          })
          .catch((error) => {
            notAllowMsgCheck(error);
            setConfirmLoading(false);
            message.error("Unable to save data");
          });
      } else {
        message.warn("Kindly fill group carefully");
      }
    }
  };

  const showConfirmDelete = (id) => {
    confirm({
      title: "Delete ?",
      content: `"Are you sure you want to delete"`,
      okText: "Yes",
      cancelText: "No",
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
      onOk() {
        handleDelete({ Behavior: 2, SalesTaxID: id });
      },
      onCancel() {
        //console.log('Cancel');
      },
    });
  };



  const handleDelete = (body) => {
    setConfirmLoading(true);
    ds.postTax(body, BEHAVIOUR_TYPE.DELETE)
      .then((res) => {
        if (res && res == "Deleted") {
          if (body.GroupTaxID) setloadGroupData(!loadGroupData);
          else setloadDataState(!loadDataState);
          message.success("Data deleted successfully");
        } else if (res && res == "Assigned Tax") {
          setConfirmLoading(false);
          message.warn("Caution: This Tax is already assigned.", 4);
        } else if(res && res == "exist_in_group"){
          setConfirmLoading(false);
          message.warn("Caution: This Tax exist in a group tax", 4);
        } else {
          setConfirmLoading(false);
        }
      })
      .catch((error) => {
        notAllowMsgCheck(error);
        setConfirmLoading(false);
        message.error("Something went wrong");
      });
  };

  const handleEdit = (taxId) => {
    debugger
    setConfirmLoading(true);
    ds.getSalesDiscountById(
      {
        SalesDiscountID: taxId,
      },
      BEHAVIOUR_TYPE.GET
    )
      .then((res) => {
        debugger
        setIsPercent(res.isFix ? false : true);
        setTaxValue(`${res.discountRate}`);
        setIsEdit(true);
        setVisible(true);
        setIsDiscountActive(res.isActive);
        setTaxId(taxId);
        setIsPercent(res.isActive ? true : false);
        setConfirmLoading(false);
        form.setFieldsValue({
          discountCode: res.discountCode,
          discountName: res.discountName,
          discountRate: res.discountRate
        });
      })
      .catch((e) => {
        debugger
        notAllowMsgCheck(e);
      });
  };

  const plainOptions = ["In Percentage %", "Fixed Amount"];

  function addRow() {
    let oneMore = getRandomInt(10000000);
    setNbrOfFields(getNbrOfFields.concat(oneMore));
  }

  function deleteRow(e) {
    let supposedArr = getNbrOfFields.filter((a) => a !== e);
    setNbrOfFields(supposedArr);
  }


  const valideDuplicateName = (rule, value, callback) => {
    debugger
    const currentDiscountName = taxData.find(item => item.id === taxId)?.discountName; 
    const isDuplicate = taxData.some(item => 
      item.discountName.toLowerCase() === value.toLowerCase() &&
      (!isEdit || item.discountName.toLowerCase() !== currentDiscountName.toLowerCase())
    );
  
    if (isDuplicate) {
      callback("Discount Name already exists. Add a different name.");
    } else {
      callback();
    }
  };


  const valideDuplicateCode = (rule, value, callback) => {
    debugger
    const currentDiscountCode = taxData.find(item => item.id === taxId)?.discountCode; 
    const isDuplicate = taxData.some(item => 
      item.discountCode.toLowerCase() === value.toLowerCase() &&
      (!isEdit || item.discountCode.toLowerCase() !== currentDiscountCode.toLowerCase())
    );
  
    if (isDuplicate) {
      callback("Discount Code already exists. Add a different code.");
    } else {
      callback();
    }
  };
  

  const SalesDiscount = () => {
    return (
      <Modal
        title={
          isEdit ? (
            <IntlMessages id="setup.salesDiscount.editSalesDiscount" />
          ) : (
            <IntlMessages id="setup.salesDiscount.addSalesDiscount" />
          )
        }
        visible={visible}
        okText={
          isEdit ? (
            <IntlMessages id="common.resource.update" />
          ) : (
            <IntlMessages id="setup.salesDiscount.addSalesDiscount" />
          )
        }
        okButtonProps={{
          className: "dk-btn-add",
        }}
        cancelButtonProps={{
          className: "dk-btn-cancel",
        }}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              postTaxService(values);
            })
            .catch((info) => {
              // console.log("Validate info",info)
            });
        }}
        // width={350}
        centered={true}
      >
        <Form
          {...formItemLayout}
          form={form}
          // onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          initialValues={{
            prefix: "86",
          }}
          className="custom-mg-top-26"
          scrollToFirstError
          id="AddSalesTaxForm"
          name="AddSalesTaxForm"
        >
          <Form.Item
            className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
            name="discountName"
            label={
              <strong>
                <IntlMessages id="setup.salesDiscount.disNamelbl" />
              </strong>
            }
            rules={[
              {
                required: true,
                message: <IntlMessages id="products.promoadd.disperalert" />,
              },
              {
                validator: valideDuplicateName,
              },
            ]}
          >
            <Input maxLength={20} />
          </Form.Item>
          <p style={{marginLeft: 16, color: '#6692b0'}}>Only 20 characters code allowed</p>

<Form.Item
            className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
            name="discountCode"
            label={
              <strong>
                <IntlMessages id="setup.salesDiscount.disCodelbl" />
              </strong>
            }
            rules={[
              {
                required: true,
                message: <IntlMessages id="products.promoadd.disperalert" />,
              },
              {
                validator: valideDuplicateCode,
              },
            ]}
          >
            <Input maxLength={2} />
          </Form.Item>
          <p style={{marginLeft: 16, color: '#6692b0'}}>Only 2 characters code allowed</p>
          <div style={{ marginTop: isEdit ? 14 : 0 }}>
                    <Form.Item
                      className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
                      name="isActive"
                      label={
                        <strong>
                          <IntlMessages id="setup.salesDiscount.disActivelbl" />
                        </strong>
                      }
                    >
                      <Switch
                        checked={isDiscountActive}
                        onChange={() =>
                            setIsDiscountActive(!isDiscountActive)
                        }
                      />
                    </Form.Item>
                    </div>
          
          {!isEdit ? (
            <Form.Item
              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
              name="discountRate"
              label={
                <strong>
                  <IntlMessages id="setup.salesDiscount.disRatelbl" />
                  {isPercent
                    ? " %"
                    : getCurrData.currencyCode
                    ? ` ${getCurrData.currencyCode}`
                    : ""}
                </strong>
              }
              rules={[
                {
                  required: true,
                  message: <IntlMessages id="products.promoadd.disperalert" />,
                },
                {
                  validator: (_, value) => {
                    if (value <= 0) {
                      return Promise.reject(
                        <IntlMessages id="setup.salesDiscount.invalidDiscountRate" />
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              style={{ width: "50%" }}
            >
              <InputNumber type="number" />
            </Form.Item>
          ) : (
            <div>
              <Row gutter={10}>
                <Col push={1}>
                  <strong>
                  <IntlMessages id="setup.salesDiscount.disRatelbl" />
                    {isPercent
                      ? " %"
                      : getCurrData.currencyCode
                      ? ` ${getCurrData.currencyCode}`
                      : ""}
                  </strong>
                </Col>
                <Col push={1}>{getTaxValue}</Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col push={2}>
                  <IntlMessages id="setup.salesDiscount.tomake" />
                </Col>
              </Row>
              <Row>
                <Col push={2}>
                  <a
                    onClick={() => {
                      setIsEdit(false);
                      form.resetFields();
                    }}
                    className="gx-icon-text"
                  >
                    <strong style={{ fontSize: "medium" }}>
                      <IntlMessages id="setup.salesDiscount.addnew" />,
                    </strong>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col push={2}>
                  <IntlMessages id="setup.salesDiscount.thenswap" />
                </Col>
              </Row>
            </div>
          )}
        </Form>
        <div style={{ marginTop: isEdit ? 14 : 0 }}>
          <Checkbox.Group
            style={{ marginLeft: 16 }}
            options={plainOptions}
            value={isPercent ? "In Percentage %" : "Fixed Amount"}
            onChange={() => setIsPercent(!isPercent)}
            disabled={isEdit}
          />
          <p style={{ marginTop: 14, marginLeft: 16 }}>
            {isPercent ? (
              <strong>
                <IntlMessages id="setup.general.salesDiscount.fixpercent" />
              </strong>
            ) : (
              <strong>
                <IntlMessages id="setup.general.salesDiscount.fixrate" />
              </strong>
            )}
          </p>
        </div>

      </Modal>
    );
  };
  return getIsAllowRead ? (
    <Spin
      spinning={confirmLoading}
      tip={<IntlMessages id="sell.cashlisting.cashloading" />}
      size="large"
    >
      <>
        <SalesDiscount />
        <div className="Content-wrapper SalesTax-pg">

        <Row className="align-items-center justify-content-between mb-3 saletax-header">
            <Col lg={12} md={12} sm={24} xs={24}>
            <h1 className="mb-0">
                <IntlMessages id="setup.salesDiscount.salesDisTitle1" />
              </h1>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
            <div className="pg-header-btn mt-10-md">
                <Button
                  className="dk-btn-add"
                  type="primary"
                  onClick={() => {
                    setIsPercent(true);
                    setVisible(true);
                    setIsEdit(false);
                  }}
                  size="large"
                  disabled={getIsDisableCreate}
                >
                  <IntlMessages id="setup.salesDiscount.addSalesDiscount" />
                </Button>
              </div>
            </Col>
          </Row>


         
            <Table
              className="gx-table-responsive"
              key={taxData.id}
              columns={columnsTable1}
              dataSource={taxData}
            />
         
        </div>
      </>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  );
};

export default SalesDiscount;
